import ButtonLogin from './ButtonLogin';

export default ButtonLogin;


// WEBPACK FOOTER //
// ./src/scenes/Login/components/ButtonLogin/index.ts